export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-popover/index.js